export const SNAKE_CASE_PATTERN = /^[a-z0-9]+(_[a-z0-9]+)*$/;

export const SNAKE_CASE_VALIDATION_MESSAGE =
  'Event names must be lowercase in snake case format (e.g. "test_event_123")';

export default function snakeCase(value) {
  return SNAKE_CASE_PATTERN.test(value) || SNAKE_CASE_VALIDATION_MESSAGE;
}
